import React from 'react';

import { useSelectorUserProfile } from '../../user-profile';
import { EmailVerificationModal } from '../email-verification-modal/email-verification-modal';
import { useShouldShowEmailVerification } from './use-check-mail.verification';

export type CheckMailVerificationStatusProps = {
    isVerifyEmailTimeframeExpired: boolean | null
    isFirstLogin: boolean| null
    emailStatus: string| null
};

const CheckMailVerificationStatus = () => {
    const userDetails = useSelectorUserProfile();
    const showEmailVerificationModal = useShouldShowEmailVerification(userDetails);

    return (
        <>
            {showEmailVerificationModal ?
                <EmailVerificationModal
                    isModalOpen={true}
                    isError={false}
                    errorCode={null}
                    userDetails={userDetails}
                /> : null
            }
        </>
    );
};

export default CheckMailVerificationStatus;
